export const UIExportHtmlTable = ({ columns, data }) => {
  function renderCell(value) {
    if (typeof value === 'boolean') {
      return value ? 'Yes' : 'No' // Convert boolean to string
    } else if (typeof value === 'string' || typeof value === 'number') {
      return String(value) // Convert string or number to string
    } else {
      return null // Return null for unsupported types
    }
  }

  const htmlContent = `<!DOCTYPE html>
    <html xmlns="http://www.w3.org/1999/xhtml">
      <head>
        <title>Exported Data</title>
      </head>
      <body>
        <table border="1">
          <thead>
            <tr>
              ${columns
                .map(
                  ({ title }, index) =>
                    `<th key="${index}">${title.replace(/_/g, ' ')}</th>`
                )
                .join('')}
            </tr>
          </thead>
          <tbody>
            ${data
              .map(
                (item, index) =>
                  `<tr key="${index}" className="bg-gray1">
                  ${columns
                    .map(
                      ({ column }, columnIndex) =>
                        `<td key="${columnIndex}">${renderCell(item[column])}</td>`
                    )
                    .join('')}
                </tr>`
              )
              .join('')}
          </tbody>
        </table>
      </body>
    </html>`

  return htmlContent
}
